<template>
  <div>
    <template v-if="users.length > 0">
      <template v-for="(u, i) in showUsers">
        <div class="my-calendar" :key="i + '-users'" v-if="u.user_hash === user.userHash">
          <CalendarAPIStatus
            :user="u"
            :selfUser="user"
            :calendarSettings="calendarSettings"
            :default="true"
            :isSync="true"
            :usersStatusAPI="usersStatusAPI"
            @changeShowEvent="changeShowEvent"
            @changeShowEventSelf="changeShowEventSelf"
            @createCalendarSettings="createCalendarSettings"
          />
          <div style="width: calc(100% - 48px); display: flex">
            <p
              class="member"
              :class="{ '-pointer': isEditableCalendarSettings(u) }"
              style="padding-left: 8px"
            >
              <Tooltip :message="u.email">
                <span style="margin-left: 4px; margin-right: 8px">{{ u.username }}</span>
              </Tooltip>
            </p>
          </div>
        </div>
      </template>
    </template>
    <template v-if="users.length > 0">
      <template v-for="(u, i) in showUsers">
        <div class="my-calendar" :key="i + '-users'" v-if="u.user_hash != user.userHash">
          <CalendarAPIStatus
            :user="u"
            :selfUser="user"
            :calendarSettings="calendarSettings"
            :default="true"
            :isSync="true"
            :usersStatusAPI="getUsersStatus(u)"
            @changeShowEvent="changeShowEvent"
            @changeShowEventSelf="changeShowEventSelf"
            @createCalendarSettings="createCalendarSettings"
          />
          <div style="width: calc(100% - 48px); display: flex">
            <p
              class="member"
              :class="{ '-pointer': isEditableCalendarSettings(u) }"
              style="padding-left: 8px"
            >
              <Tooltip :message="u.email">
                <span style="margin-left: 4px; margin-right: 8px">{{ u.username }}</span>
              </Tooltip>
            </p>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import CalendarAPIStatus from '@/views/DashBoard/Calendar/CalendarAPIStatus'
import Tooltip from '@/components/atoms/tooltips/Tooltip'

export default {
  components: {
    CalendarAPIStatus,
    Tooltip,
  },
  props: {
    users: {
      type: Array,
      required: false,
    },
    user: {
      type: Object,
      required: false,
    },
    calendarSettings: {
      type: Array,
      required: true,
    },
    changeShowEvent: {
      type: Function,
      required: true,
    },
    changeShowEventSelf: {
      type: Function,
      required: true,
    },
    createCalendarSettings: {
      type: Function,
      required: true,
    },
    isEditableCalendarSettings: {
      type: Function,
      required: true,
    },
    usersStatusAPI: {
      type: Array,
      required: true,
    },
    getUsersStatus: {
      type: Function,
      required: true,
    },
  },
  computed: {
    showUsers () {
        // カレンダー関連で使用する場合はログイン不可ユーザーを表示しない
        return this.users.filter(user => {return user.permission < 3})
    },
  },
}
</script>

<style scoped lang="scss">
.my-calendar {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/CalendarAPIStatusUsers.vue